import { cv } from "@suse-o11y/class-variance";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import React, { type FC } from "react";

import { Button } from "../buttons/Button";

const variants = cv(null, {
	variants: {
		size: {
			small: "h-[23px] px-1.5 text-[9px]/[23px]",
			middle: "px-2 text-xs/6",
		},
		disabled: {
			true: "pointer-events-none",
		},
	},
});

export declare type IconButtonSize = "small" | "middle";

export interface IconButtonProps {
	icon: React.ReactNode;
	onClick: () => void;
	tooltip: string;
	disabled?: boolean;
	className?: string;
	size?: IconButtonSize;
}

export const IconButton: FC<IconButtonProps> = ({
	icon,
	onClick,
	tooltip,
	disabled,
	size = "small",
	className,
	...props
}) => (
	<TooltipBoundary>
		<TooltipTrigger asChild>
			<Button
				size={size}
				{...props}
				className={variants({ size, disabled, className })}
				disabled={disabled}
				onClick={() => {
					if (!disabled) {
						onClick();
					}
				}}
			>
				{icon}
			</Button>
		</TooltipTrigger>

		<Tooltip className="tooltip/tooltip">{tooltip}</Tooltip>
	</TooltipBoundary>
);
